/**
 * Safety Alert submit-form validation (REG-010).
 *
 * Centralised so the submit button's enabled state, the inline hints, and the
 * submit handler all use ONE source of truth — preventing the regression where
 * an Official's submit button stayed silently disabled because the town was
 * tracked in lagging state rather than derived from their profile.
 *
 * For Official/Town Hall accounts the caller passes `effectiveTown` derived
 * directly from the profile (officialSafetyTown), so the form is valid the
 * instant the profile loads.
 */
export function missingSafetyFields({ effectiveTown, title = '', body = '', confirmed } = {}) {
  const missing = [];
  if (!effectiveTown) missing.push('town');
  if ((title || '').trim().length < 4) missing.push('title');
  if ((body || '').trim().length < 10) missing.push('body');
  if (!confirmed) missing.push('confirm');
  return missing;
}

export function isSafetyFormReady(form) {
  return missingSafetyFields(form).length === 0;
}
